export default "__VITE_ASSET__CpSnEZyH__"